import CouponStats from './CouponStats';
// import SalesGeneratedGraph from './SalesGenerated.Graph';
// import { customerAcquisition, salesGeneratedUsingCoupon } from '../../ChartData';
// import CustomerAcquisitionsGraph from './CustomerAcquisitions.Graph';
import CouponsList from './CouponsList';

function CouponInsights() {
    return (
        <>
            <CouponStats />

            <div className="flex mt-3 mx-5">
                {/* <SalesGeneratedGraph 
                    salesGeneratedByCouponData={salesGeneratedUsingCoupon} 
                /> */}
            </div>

            <div className="flex mt-3 mx-5">
                {/* <CustomerAcquisitionsGraph 
                    customerAcquisitionData={customerAcquisition} 
                /> */}
            </div>

            <div className="flex mt-4 mx-5">
                <CouponsList />
            </div>
        </>
    );
}

export default CouponInsights;
